import { Spinner, SpinnerProps } from "./spinner";

type LoadingProps = SpinnerProps;

const Loading = (props: LoadingProps) => (
  <div className="absolute inset-0 bg-white/60 z-modal flex justify-center items-center">
    <Spinner data-testid="loading-spinner" {...props} />
  </div>
);

export { LoadingProps, Loading };
